
import 'swiper/css/swiper.css'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { LoginVO } from '@/views/biz/login/vo/login.vo'
import axios from 'axios'

@Component
export default class FindPasswordConfirm extends Vue {
  member: LoginVO = {} as LoginVO;
  active = true;

  get isSend() {
    return this.active? this.$t('login.t0001'): this.$t('login.t0002');
  }
  
  nextStep() {
    if(!this.member.memEmail) {
      // 이메일주소를 입력해주세요.
      return alert(this.$t('join.a0040'));
    }
    if(!this.active){
      return alert(this.$t('login.a0015'));
    }

    // 이메일 존재 여부 확인 후 이메일 발송
    axios.post('/login/password/reset', this.member)
    .then(()=> {
      this.active = false;
      // 메일이 발송됐습니다.
      this.$toast(this.$t('login.a0012'));
      // this.$router.push({name: 'Login'});
    })
  }
}
